import { useFormInput } from 'js/lib/form'

const PLACEHOLDER_CLASS = 'c-select--with-placeholder'

const selects = document.querySelectorAll('.js-c-form-select')
selects.forEach(initialize)

function initialize(select) {
  const { onDependentChange } = useFormInput(select)

  select.addEventListener('change', () => {
    select.classList.remove(PLACEHOLDER_CLASS)
  })

  // on load remove the placeholder class
  if (select.value !== '') {
    select.classList.remove(PLACEHOLDER_CLASS)
  }

  onDependentChange(dependency => handleDependentChange(select, dependency))
}

function handleDependentChange(select, dependency) {
  switch (dependency.behaviour.type) {
    case 'options':
      updateOptions(select, dependency.behaviour.getOptions())
      break
    case 'value':
      updateValue(select, dependency.behaviour.getValue())
      break
  }
}

function updateOptions(select, optionsHash) {
  if (!optionsHash) return

  // Remove all existing options except optgroups and options with the placeholder class
  for (let i = select.options.length - 1; i >= 0; i--) {
    const option = select.options[i]
    if (
      option.parentElement === select && // not inside an optgroup
      !option.classList.contains('js-c-form-select-placeholder')
    ) {
      select.remove(i)
    }
  }

  // Add new options from the hash
  Object.entries(optionsHash).forEach(([value, text]) => {
    const option = document.createElement('option')
    option.value = value
    option.text = text
    select.add(option)
  })
}

function updateValue(select, value) {
  const option = Array.from(select.options).find(opt => opt.value === String(value))
  if (option) {
    select.value = String(value)
    select.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }))
  }
}
